import { getBootstrapData } from "@swa-ui/bootstrap";

/**
 * Function that fetches promo codes enabled in the current environment through bootstrap data
 * and maps them to an appropriate format for consumption in the CarSection component.
 *
 * @returns {Array} Array containing promo codes mapped as benefits.
 */
export function getCarVendorBenefits() {
  const carVendorConfig = getBootstrapData("car-vendor-config");
  const { promoCodes = [] } = carVendorConfig || {};
  const benefits = promoCodes.map(({ promoCode, promoCodeType, vendorCode }) => ({
    "@code": promoCode,
    "@type": promoCodeType,
    "@xmlType": vendorCode,
  }));

  return benefits;
}
